export { default } from './PlayerControls';
